import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import EditEventCard from '../Card/EditEventCard';
import Amplify, { Auth } from 'aws-amplify';
import config from '../../aws-exports'
import Lottie from 'react-lottie';
import { default as animationData } from '../../assets/loader.json'
import { useLocation } from "react-router";
import CreateEvent from '../Card/CreateEvent';
import PopUp from './PopUp'
import EditNewQuestions1 from '../EditNewQuestions1'
import DeleteEvent from './DeleteEvent'
import ReOpenAssignment from './ReOpenAssignment'
import { cx } from '@emotion/css';
import * as styles from './challanges.style.js';
import batchImg from '../../assets/images/challenge-banner.png';

import {
  withAuthenticator, AmplifySignOut
} from "aws-amplify-react"

Amplify.configure(config)

function CreateEvents(props) {

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenquestion, setIsOpenquestion] = useState(false);
  const [isShowDeleteEvent, setIsShowDeleteEvent] = useState(false);
  const [isReopenAssignment, setisReopenAssignment] = useState(false);


  const [events, set_events] = useState([]);
  const [addevents, set_addevents] = useState([]);
  const [loadedevents, set_loadedevents] = useState(false);
  const [eventname, set_eventname] = useState("");
  const [eventid, set_eventid] = useState("");
  const [event_category, set_event_category] = useState("");




  const [specificcategory, set_specificcategory] = useState([]);
  const [levels, set_levels] = useState([]);
  const [limits, set_limits] = useState([]);
  const [eventdisplay, set_eventdisplay] = useState("");
  const [category, set_category] = useState("");


  let data1 = useLocation();
  ////console.log("Calling EventsScreen.....")
  ////console.log(data1.state)


  //  const togglePopup = () => {
  //      ////console.log("Calling closing windows")
  //     setIsOpen(!isOpen);
  //   }


  function togglePopup() {

    setIsOpen(!isOpen);


  }
  function AddEvent() {
    ////console.log("Calling Add Events")
    setIsOpen(!isOpen);
    // set_events([{"id":1 ,"category":"Sports", "count":6 },{"id":2 ,"category":"Sports", "count":5 }])     

  }

  function computeAnswer(eventname) {


    ////console.log("REached parent screen")
    ////console.log(eventname)
    //  set_events([{"id":1 ,"category":"Sports", "count":6 },{"id":2 ,"category":"Sports", "count":5 }])    
    setIsOpen(!isOpen);
    set_events([{}])
    getToken()


  }


  function completedeletion(eventname) {

    setIsShowDeleteEvent(!isShowDeleteEvent)
    set_events([{}])
    getToken()


  }

  function addquestions(eventname) {

    ////console.log("We will try to add questions")
    setIsOpenquestion(!isOpenquestion)

  }



  function closeeditquestionswindow() {

    setIsOpenquestion(!isOpenquestion)

  }

  function showeditquestions(specificcategory, levels, limits, eventdisplay, category) {

    ////console.log(specificcategory)
    ////console.log(levels)
    ////console.log(limits)
    ////console.log(eventdisplay)
    ////console.log("********")
    ////console.log(category)


    set_specificcategory(specificcategory)
    set_levels(levels)
    set_limits(limits)
    set_eventdisplay(eventdisplay)
    set_category(category)


    ////console.log("We will Show edit questions")
    setIsOpenquestion(!isOpenquestion)

  }
  function showdeleteevents(eventname) {

    ////console.log(eventname)
    ////console.log("Done deleting event")
    setIsShowDeleteEvent(!isShowDeleteEvent)

  }

  function ReopenAssignment(eventname) {

    ////console.log(eventname)
    ////console.log("Done deleting event")
    setisReopenAssignment(!isReopenAssignment)

  }
  function showdeleteevents2(id, eventname, category) {

    ////console.log(id)
    ////console.log(eventname)
    set_eventname(eventname)
    set_event_category(category)
    set_eventid(id)


    ////console.log("Done deleting event")
    setIsShowDeleteEvent(!isShowDeleteEvent)

  }

  function showReOpenAssignment(id, eventname, category) {


    set_eventname(eventname)
    set_event_category(category)
    set_eventid(id)
    setisReopenAssignment(!isReopenAssignment)
  }


  function closedeleteeventwindow() {

    setIsShowDeleteEvent(!isShowDeleteEvent)

  }

  function closereopeneventwindow() {

    setisReopenAssignment(!isReopenAssignment)

  }
  // const getToken = async () => {

  //   Auth.currentSession().then(res => {
  //     let accessToken = res.getAccessToken()
  //     let jwt = accessToken.getJwtToken()
  //     //////console.log(res)
  //     //////console.log(Auth.user.username)
  //     //////console.log(props.category) 
  //     //this.props.setCategory(String(Auth.user.username))    

  //     getEventsfromDB(Auth.user.username, jwt)

  //   })

  // };


  const getToken = async () => {
    let user = null;
    try {
      user = await Auth.currentAuthenticatedUser();


      Auth.currentSession().then((res) => {
        let accessToken = res.getAccessToken();
        let jwt = accessToken.getJwtToken();

        if (user.username.includes("Google_")) {

          getEventsfromDB(user.attributes['email'], jwt);



        }
        else {

          getEventsfromDB(user.username, jwt);


        }





      });




    } catch (error) {
      // console.log(error)
      Auth.signOut();
    }
  };



  const getEventsfromDB = async (username, jwt) => {

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': jwt },
      // body: JSON.stringify({'question': id , 'tablename': category+"Questions",'level': level})
      body: JSON.stringify({ 'username': username })


    };
    ////console.log(requestOptions)  
    const response = await fetch(`https://api.prod.quizwizard.net/quiz/listeventsbyowner`, requestOptions)
    const data = await response.json();
    //////console.log('Output from the API is ')  
    //////console.log(data)
    var i, j;
    var loopData = []
    var count = 0
    for (i = 0; i < data.length; i++) {
      //////console.log(data[i]['events'][0]) 
      for (j = 0; j < data[i]['events'].length; j++) {
        //////console.log(data[i]['events'][j])
        loopData[count] = data[i]['events'][j]
        count = count + 1
      }

      //loopData[i] = data[i]['events']
      // for(j=0; j < data[i]['events']; j++){
      //   ////console.log(data[i]['events'][j])
      //   loopData[count] = data[i]['events'][j]
      //   count = count + 1 
      // }


    }
    // ////console.log(data[0]['events'])

    //////console.log(loopData)  
    //////console.log(loopData)
    //////console.log(data[0]['events'])                                                                 
    //set_events(data[0]['events'])
    set_events(loopData)
    set_loadedevents(true)
  };



  useEffect(() => {
    // You need to restrict it at some point
    // This is just dummy code and should be replaced by actual
    // ////console.log("useEffect called on EventsScreen")
    getToken();
    set_addevents([{ "id": 1, "category": "Create New Challenge", "count": 6 }])
    document.title = 'Challenges';


  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  let eventCards = events.map(events => {
    return (

      <div className="col-md-4">
        {isShowDeleteEvent && <DeleteEvent
          closedeleteevents={answer => completedeletion(answer)}
          closedeleteeventwindow={closedeleteeventwindow}
          category={event_category}
          eventid={eventid}
          name={eventname}
        />}

        {isReopenAssignment && <ReOpenAssignment
          ReopenAssignment={answer => completedeletion(answer)}
          closereopeneventwindow={closereopeneventwindow}
          category={event_category}
          eventid={eventid}
          name={eventname}

        />}
        <Col className="py-2 border rounded">
          <EditEventCard imgsrc={"../assets/" + events.name + ".png"} title="Algebra" key={events.id} levels={events.levels} totalquestions={events.totalquestions} event={events} category={data1.state} target="" showeditquestions={(specificcategory, levels, limits, eventdisplay, category) => showeditquestions(specificcategory, levels, limits, eventdisplay, category)} ReopenAssignment={(id, answer, category) => showReOpenAssignment(id, answer, category)} showdeleteevents={(id, answer, category) => showdeleteevents2(id, answer, category)} />
        </Col>
      </div>
    )
  })


  let addeventCards = addevents.map(eventcategory => {
    return (

      <div className="col-md-4">
        {isOpen && <PopUp
          handleClose={togglePopup}

          //handleClose={eventname =>togglePopup(eventname)
          selected={answer => computeAnswer(answer)}

        />}

        {isOpenquestion && <EditNewQuestions1
          addquestions={answer => addquestions(answer)}
          closeeditquestionswindow={closeeditquestionswindow}
          specificcategory={specificcategory}
          levels={levels}
          limits={limits}
          eventdisplay={eventdisplay}
          category={category}


        />}

        <Col className="py-2 border rounded" key="123" >
          <CreateEvent imgsrc={"../assets/" + eventcategory.category + ".png"} title="Algebra" key="12344" eventcategory={eventcategory} target="events"
            onclick={dummyvar => AddEvent()} />
        </Col>
      </div>
    )
  })

  return (
    <div>
      <div className={cx(styles.batchBanner)}>
        <img src={batchImg} alt="" />
      </div>
      <div className={cx(styles.batchTitle)}>Create New Challenges</div>
      {loadedevents ?
        <div className={cx(styles.challangeContainer)}>
          <Container fluid> <Row>   {addeventCards} {eventCards}</Row></Container></div> : <div className="welcomecenter"><Lottie options={defaultOptions} height={400} width={400} />
        </div>
      }
    </div>

  )

}

export default CreateEvents;
